import { useState } from "react";
import UploadIcon from "../../assets/icons/admin-customer-icons/upload-icon";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../helper-components/loading-spinner";
import { imageUploadAction } from "../../redux/actions/general-action";
import { useFormikContext } from "formik";
import { toImageUrl } from "../../utils/image-url";

export default function UploadImg({ title, name, onUploadSuccess, data }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { setFieldValue, values, errors } = useFormikContext();
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    setLoading(true);
    setError(null);
    setSelectedFile(file);

    dispatch(imageUploadAction(file, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setLoading(false);
    const imageUrl = toImageUrl(data);
    setFieldValue(name, imageUrl);

    // Call the callback to trigger localStorage update
    if (onUploadSuccess) {
      onUploadSuccess(name, imageUrl);
    }
  };

  const onError = (errorData) => {
    setLoading(false);
    setError("Upload failed. Please try again.");
    setSelectedFile(null);
    console.error("Upload error:", errorData);
  };

  const handleClick = () => {
    document.getElementById(`file-input-${name}`).click();
  };

  return (
    <div className="flex flex-col gap-[6px]">
      <div className="relative">
        <label
          className={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
        >
          {title}
        </label>
      </div>

      <div className="flex gap-2 items-center">
        <div
          className="bg-white border flex items-center h-[42px] border-[var(--dashboard-gray-300)] rounded-lg px-[17px] text-center cursor-pointer"
          onClick={handleClick}
        >
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <input
                id={`file-input-${name}`}
                type="file"
                className="hidden"
                onChange={handleFileChange}
                accept=".pdf,.jpg,.jpeg,.png"
              />
              <div className="flex flex-row items-center gap-2">
                <UploadIcon />
                <span
                  className={`whitespace-nowrap text-[var(--alert-management-label-color)] text-[length:var(--customer-info-fs)] font-[var(--customer-default-fw)]`}
                >
                  Upload File
                </span>
              </div>
            </>
          )}
        </div>

        <div className="flex flex-col">
          <span
            className={`text-[var(--customer-set-default-fg)] text-[length:var(--customer-info-fs)] font-[var(--customer-nav-fw)]`}
          >
            {console.log(data, ">")}
            {data ? data : selectedFile ? selectedFile.name : "No file chosen"}
          </span>
          {error && <span className="text-red-500 text-sm mt-1">{error}</span>}
        </div>
      </div>

      {errors[name] && (
        <span className="text-red-500 text-sm">{errors[name]}</span>
      )}
    </div>
  );
}
